/** @jsxRuntime classic */
/** @jsx jsx */
import { gql } from '@apollo/client';
import { P } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function Viticulture({ wine, ...rest }) {
  if (!wine?.viticulture) return null;
  return (
    <Section title={<Trans>Viticulture</Trans>} {...rest}>
      {wine.viticulture.split('\n\n').map((p, index) => (
        <P key={index} variant="large">
          {p}
        </P>
      ))}
    </Section>
  );
}

export const fragment = graphql`
  fragment Viticulture on Wine {
    viticulture
  }
`;

Viticulture.fragment = gql`
  fragment Viticulture on Wine {
    viticulture
  }
`;
